<template>
	<vx-card no-shadow id="resource-settings">
		<vs-row vs-w="12">
			<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
				<label class="vs-input--label">{{ $t("SearchBy") }}</label>
				<v-select
					v-model="searchFieldSelected"
					:clearable="false"
					:options="searchOptions"
					v-validate="'required'"
					name="country"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
				</v-select>
			</vs-col>

			<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
				<!-- Append Two Buttons -->
				<vx-input-group class="mt-2 mb-2">
					<vs-input
						icon-no-border
						:placeholder="$t('Search')"
						v-model="searchQuery"
						@keyup.enter="searchResource"
						class="w-full"
					/>

					<template slot="append">
						<div class="append-text btn-addon">
							<vs-button
								:title="$t('Search')"
								color="primary"
								type="border"
								icon-pack="feather"
								icon="icon-search"
								@click="searchResource"
							></vs-button>

							<vs-button
								:title="$t('Schedule.Refresh')"
								color="primary"
								type="border"
								icon-pack="feather"
								icon="icon-refresh-cw"
								@click="refresh"
							></vs-button>
						</div>
					</template>
				</vx-input-group>
				<!-- /Append Two Buttons -->
			</vs-col>
		</vs-row>

		<p class="mt-base">
			{{ $t("Resource.Resources") }}
		</p>

		<vs-divider class="d-theme-border-grey-light mt-1" />

		<vue-perfect-scrollbar :style="scrollArea" :settings="settings">
			<!-- RESOURCE LIST -->
			<div id="card-resource-list">
				<ul class="bordered-items" v-if="resourcesDataFilter.length > 0">
					<li
						class="cursor-pointer border p-3 hover:font-semibold flex items-center card-resource-list-item"
						v-for="resource in resourcesDataFilter"
						:key="resource.uid"
						@click="handleResourceItemClick(resource)"
					>
						<feather-icon
							icon="UserIcon"
							:title="$t('Duplicate')"
							svgClasses="w-5 h-5 hover:text-success stroke-current"
							class="mr-2"
						/>

						{{ resourceFullname(resource) | capitalize }}
					</li>
				</ul>
				<p v-else>
					<vs-alert class="mb-2" color="primary">
						{{ $t("general.NoResultsFoundFor") + " " }}<em class="font-semibold">"{{ searchQuery }}"</em>
					</vs-alert>
				</p>
			</div>
		</vue-perfect-scrollbar>

		<vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-5" />
	</vx-card>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

import NotPermission from "@/views/pages/NotPermission.vue";
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	name: "FollowerFormResourceSelection",
	components: {
		VuePerfectScrollbar,
		NotPermission,
		vSelect,
	},
	props: {
		scrollArea: {
			type: Object,
			default: () => {
				return {
					margin: " auto",
					width: " 100%",
					height: " 350px",
				};
			},
		},
	},
	data() {
		return {
			searchQuery: null,

			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.7,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 100,

			checkedAll: false,
			searchField: "Name",
			// Style loading
			backgroundLoading: "#FFFFFF",
			colorLoading: "primary",
			searchFieldSelected: {value: "Name", label: this.$t("Name")},
		};
	},
	watch: {
		currentPage(val) {
			this.getResources();
		},
		searchFieldSelected(val) {
			this.searchField = val.value;
		},
	},
	computed: {
		resources() {
			return this.$store.state.moduleResource.resources; //.map(resource => ({...resource, selected : false}));
		},
		resourcesDataFilter() {
			const data = this.resources;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
					r.email.toLowerCase().includes(this.searchQuery.toLowerCase())
				);
			});
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},

		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		resourceFullname() {
			return (resource) => {
				return `${resource.name} ${resource.lastname}`;
			};
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Lastname", label: this.$t("Lastname")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Email", label: this.$t("Email")},
			];
		},
	},
	methods: {
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundLoading,
				color: this.colorLoading,
				container: "#card-resource-list",
				scale: 1,
			});
		},
		closeLoadingContained() {
			this.$vs.loading.close("#card-resource-list > .con-vs-loading");
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},

		getResources(
			dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
			}
		) {
			this.openLoadingContained();
			const r = this.$store.getters["moduleRoles/getExcuteSupervisorRolesId"];

			this.$store
				.dispatch("moduleResource/fetchResourceFilter", {
					...dataPage,
					role_id: r,
				})
				.then((res) => {
					if (this.tabActive === 0) {
						this.resourcesDataLocal = res.data.records;
					} else {
						this.resourcesDataLocalSelect = res.data.records;
					}
					Object.assign(this.pagination, res.data.pagination);
					this.searchQuery = "";
					this.$emit("resourcesFoundEmit", res.data.records);
					this.closeLoadingContained();
				})
				.catch((err) => {
					this.closeLoadingContained();
					console.error(err);
				});
		},
		searchResource() {
			// fetchResourceFilterById
			const dataPage = {
				name: this.searchField === "Name" ? this.searchQuery : "",
				lastname: this.searchField === "Lastname" ? this.searchQuery : "",
				username: this.searchField === "Username" ? this.searchQuery : "",
				identification: this.searchField === "Identification" ? this.searchQuery : "",
				email: this.searchField === "Email" ? this.searchQuery : "",
				imei: this.searchField === "Imei" ? this.searchQuery : "",
				order_by: "name",
				sort: "ASC",
			};
			this.getResources(dataPage);
		},
		refresh() {
			const dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
			};
			this.getResources(dataPage);
		},

		handleResourceItemClick(resource) {
			this.$emit("selectedResource", resource);
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	mounted() {
		if (this.$store.state.moduleResource.resources.length <= 0) {
			this.getResources();
		}
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 475px;
	max-height: 475px;
}

.scroll-area--sidebard-height {
	margin: auto;
	width: 100%;
	min-height: 100%;
	max-height: 100%;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
	background: chocolate;
}
.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}

.card-resource-list-item:hover {
	background: #f5f5f5;
	cursor: pointer;
}
</style>
